import PayablePaymentApi from "../api/PayablePayment.api";

const PayablePaymentService = {
  /**
   * 💰 Registrar pago de Cuenta por Pagar
   * POST /api/Payable/payments
   */
  create: async (payload: any) => {
    const response = await PayablePaymentApi.add(payload);

    return response.data;
  },
};

export default PayablePaymentService;